import { getSortedChildrenPerMuscle } from "./index122.js";
import { splitArrayBy } from "./index123.js";
import { RG_TYPE } from "@project-rouge/rg-core";
function getApartmentArray(building, level) {
	const apartmentArray = [];
	const childrenPerMuscle = getSortedChildrenPerMuscle(building, level);
	for (const section of childrenPerMuscle) {
		const apartmentSections = splitArrayBy(section.children, (child) => child.type !== RG_TYPE.Apartment);
		if (apartmentSections.length > 0) apartmentArray.push(...apartmentSections);
	}
	return apartmentArray;
}
export { getApartmentArray };

//# sourceMappingURL=index124.js.map